'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SAVE_IMAGE_SUCCESS = exports.SAVE_SUCCESS = exports.EVENT_LOAD_SUCCESS = exports.DELETE_IMAGE_SUCCESS = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends4 = require('babel-runtime/helpers/extends');

var _extends5 = _interopRequireDefault(_extends4);

exports.default = reducer;
exports.removeErrors = removeErrors;
exports.isLoaded = isLoaded;
exports.changeFilter = changeFilter;
exports.load = load;
exports.newEvent = newEvent;
exports.deleteImage = deleteImage;
exports.destroy = destroy;
exports.getEvent = getEvent;
exports.restore = restore;
exports.feature = feature;
exports.save = save;
exports.saveImage = saveImage;
exports.search = search;
exports.unlink = unlink;

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

var _translations = require('helpers/translations');

var _browser = require('@sentry/browser');

var Sentry = _interopRequireWildcard(_browser);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CHANGE_FILTER = 'caligram/events/CHANGE_FILTER';
var DELETE_IMAGE = 'caligram/events/DELETE_IMAGE';
var DELETE_IMAGE_FAIL = 'caligram/events/DELETE_IMAGE_FAIL';
var DELETE_IMAGE_SUCCESS = exports.DELETE_IMAGE_SUCCESS = 'caligram/events/DELETE_IMAGE_SUCCESS';
var DESTROY = 'caligram/events/DESTROY';
var DESTROY_FAIL = 'caligram/events/DESTROY_FAIL';
var DESTROY_SUCCESS = 'caligram/events/DESTROY_SUCCESS';
var EVENT_LOAD_FAIL = 'caligram/events/EVENT_LOAD_FAIL';
var EVENT_LOAD_SUCCESS = exports.EVENT_LOAD_SUCCESS = 'caligram/events/EVENT_LOAD_SUCCESS';
var EVENT_NEW = 'caligram/events/EVENT_NEW';
var FEATURE = 'caligram/events/FEATURE';
var FEATURE_FAIL = 'caligram/events/FEATURE_FAIL';
var FEATURE_SUCCESS = 'caligram/events/FEATURE_SUCCESS';
var LOAD = 'caligram/events/LOAD';
var LOAD_FAIL = 'caligram/events/LOAD_FAIL';
var LOAD_SUCCESS = 'caligram/events/LOAD_SUCCESS';
var REMOVE_ERRORS = 'caligram/events/REMOVE_ERRORS';
var RESTORE = 'caligram/events/RESTORE';
var RESTORE_FAIL = 'caligram/events/RESTORE_FAIL';
var RESTORE_SUCCESS = 'caligram/events/RESTORE_SUCCESS';
var SAVE = 'caligram/events/SAVE';
var SAVE_FAIL = 'caligram/events/SAVE_FAIL';
var SAVE_SUCCESS = exports.SAVE_SUCCESS = 'caligram/events/SAVE_SUCCESS';
var SAVE_IMAGE = 'caligram/events/SAVE_IMAGE';
var SAVE_IMAGE_FAIL = 'caligram/events/SAVE_IMAGE_FAIL';
var SAVE_IMAGE_SUCCESS = exports.SAVE_IMAGE_SUCCESS = 'caligram/events/SAVE_IMAGE_SUCCESS';
var SEARCH = 'caligram/events/SEARCH';
var SEARCH_FAIL = 'caligram/events/SEARCH_FAIL';
var SEARCH_SUCCESS = 'caligram/events/SEARCH_SUCCESS';
var UNLINK = 'caligram/events/UNLINK';
var UNLINK_FAIL = 'caligram/events/UNLINK_FAIL';
var UNLINK_SUCCESS = 'caligram/events/UNLINK_SUCCESS';

var initialState = {
  destroyed: null,
  events: {
    data: [],
    pagination: {
      current_page: 0,
      total: 0,
      total_pages: 0
    }
  },
  event: {
    audiences: [],
    calendars: [],
    contact_email: '',
    contact_name: '',
    contact_phone: '',
    contact_url: '',
    dates: [],
    defaultVenue: {},
    defaultRoom: {},
    description: '',
    end_date: null,
    facebook_url: '',
    groups: [],
    image: null,
    images: [],
    price_currency: 'CAD',
    price_notes: null,
    price_type: null,
    prices: [],
    room: null,
    start_date: null,
    status: 'draft',
    tags: [],
    terms: [],
    translations: [],
    ticket_url: null,
    types: [],
    venue: null,
    video: null,
    video_url: null
  },
  loaded: false,
  loading: false,
  promise: null,
  queryParams: {
    page: 1,
    range: 'future',
    status: 'all',
    author: 'all',
    order: 'start_date',
    direction: 'asc',
    q: ''
  },
  saveError: {},
  saving: false,
  search: {
    data: []
  }
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  function decrementTotal() {
    var meta = state.events.meta;
    meta.pagination.total = meta.pagination.total - 1;
    return meta;
  }

  function destroyedEvent(id) {
    var index = 0;
    var events = state.events.data;

    for (index = 0; index < events.length; index++) {
      if (events[index].id === id) {
        return events.splice(index, 1)[0];
      }
    }
    return null;
  }

  function featureEvent(id) {
    var events = state.events.data;

    for (var index = 0; index < events.length; index++) {
      if (events[index].id === id) {
        events[index].featured = !events[index].featured;
        break;
      }
    }

    return events;
  }

  function incrementTotal() {
    var meta = state.events.meta;
    meta.pagination.total = meta.pagination.total + 1;
    return meta;
  }

  function parseError(error) {
    var errors = error.errors;

    return (0, _extends5.default)({}, error, {
      errors: (0, _keys2.default)(errors).reduce(function (acc, k) {
        var parts = k.split('.');

        switch (parts.length) {
          case 2:
            if (!acc[parts[0]]) {
              acc[parts[0]] = {};
            }
            acc[parts[0]][parts[1]] = errors[k];
            break;
          case 1:
          default:
            acc[k] = errors[k];
            break;
        }

        return acc;
      }, {})
    });
  }

  function restoreEvent() {
    var destroyed = state.destroyed;
    var events = state.events.data;

    events.unshift(destroyed);

    return events;
  }

  switch (action.type) {
    case LOAD:
      if (state.promise && state.promise.cancel) {
        state.promise.cancel();
      }

      return (0, _extends5.default)({}, state, {
        event: initialState.event,
        loading: true,
        loaded: false,
        promise: action.promise
      });
    case LOAD_FAIL:
      return (0, _extends5.default)({}, state, {
        error: action.error,
        events: null,
        loaded: false,
        loading: false,
        promise: null
      });
    case LOAD_SUCCESS:
      return (0, _extends5.default)({}, state, {
        error: null,
        events: action.result,
        loaded: true,
        loading: false,
        promise: null
      });
    case EVENT_NEW:
      var event = void 0;
      if (action.calendar) {
        event = (0, _assign2.default)({}, initialState.event, {
          calendars: [{
            id: action.calendar.id,
            name: action.calendar.name
          }],
          translations: [(0, _translations.newTranslation)('fr')]
        });
      } else {
        event = (0, _assign2.default)({}, initialState.event, {
          translations: [(0, _translations.newTranslation)('fr')]
        });
      }
      return (0, _extends5.default)({}, state, {
        loading: false,
        loaded: true,
        event: event,
        error: null
      });
    case EVENT_LOAD_SUCCESS:
      return (0, _extends5.default)({}, state, {
        loading: false,
        loaded: true,
        event: action.result,
        error: null
      });
    case EVENT_LOAD_FAIL:
      return (0, _extends5.default)({}, state, {
        loading: false,
        loaded: false,
        event: null,
        error: action.error
      });
    case DESTROY:
      return (0, _extends5.default)({}, state, {
        loading: true
      });
    case DESTROY_SUCCESS:
      return (0, _extends5.default)({}, state, {
        destroyed: destroyedEvent(action.id),
        events: {
          data: state.events.data,
          meta: decrementTotal()
        },
        loading: false
      });
    case DESTROY_FAIL:
      return (0, _extends5.default)({}, state, {
        loading: false
      });
    case RESTORE:
      return (0, _extends5.default)({}, state, {
        loading: true
      });
    case RESTORE_SUCCESS:
      return (0, _extends5.default)({}, state, {
        destroyed: null,
        events: {
          data: restoreEvent(),
          meta: incrementTotal()
        },
        loading: false
      });
    case RESTORE_FAIL:
      return (0, _extends5.default)({}, state, {
        loading: false
      });
    case FEATURE:
      return (0, _extends5.default)({}, state, {
        loading: true
      });
    case FEATURE_SUCCESS:
      return (0, _extends5.default)({}, state, {
        events: {
          data: featureEvent(action.id),
          meta: state.events.meta
        },
        loading: false
      });
    case FEATURE_FAIL:
      return (0, _extends5.default)({}, state, {
        loading: false
      });
    case SAVE_IMAGE:
      return (0, _extends5.default)({}, state, {
        loading: true
      });
    case SAVE_IMAGE_SUCCESS:
      return (0, _extends5.default)({}, state, {
        loading: false,
        loaded: true
      });
    case SAVE_IMAGE_FAIL:
      return (0, _extends5.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    case SEARCH:
      if (state.promise && state.promise.cancel) {
        state.promise.cancel();
      }

      return (0, _extends5.default)({}, state, {
        loading: true,
        promise: action.promise
      });
    case SEARCH_FAIL:
      return (0, _extends5.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error,
        promise: null
      });
    case SEARCH_SUCCESS:
      return (0, _extends5.default)({}, state, {
        loading: false,
        loaded: true,
        search: action.result,
        promise: null
      });
    case DELETE_IMAGE:
      return (0, _extends5.default)({}, state, {
        loading: true
      });
    case DELETE_IMAGE_SUCCESS:
      return (0, _extends5.default)({}, state, {
        loading: false,
        loaded: true
      });
    case DELETE_IMAGE_FAIL:
      return (0, _extends5.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    case SAVE:
      return (0, _extends5.default)({}, state, {
        saving: true
      });
    case SAVE_SUCCESS:
      return (0, _extends5.default)({}, state, {
        saving: false,
        loaded: false,
        saveError: (0, _extends5.default)({}, state.saveError, (0, _defineProperty3.default)({}, action.id || 'new', {}))
      });
    case SAVE_FAIL:
      Sentry.setContext('action', action);
      Sentry.setContext('state', state);
      Sentry.captureException('caligram/events/SAVE_FAIL ' + (0, _stringify2.default)(action.error));
      return (0, _extends5.default)({}, state, {
        saving: false,
        saveError: (0, _extends5.default)({}, state.saveError, (0, _defineProperty3.default)({}, action.id || 'new', parseError(action.error)))
      });
    case REMOVE_ERRORS:
      return (0, _extends5.default)({}, state, {
        saveError: {}
      });
    case CHANGE_FILTER:
      return (0, _extends5.default)({}, state, {
        queryParams: action.newFilter
      });
    case UNLINK:
      return (0, _extends5.default)({}, state, {
        loading: true
      });
    case UNLINK_SUCCESS:
      return (0, _extends5.default)({}, state, {
        destroyed: destroyedEvent(action.id),
        events: {
          data: state.events.data,
          meta: decrementTotal()
        },
        loading: false
      });
    case UNLINK_FAIL:
      return (0, _extends5.default)({}, state, {
        loading: false
      });
    default:
      return state;
  }
}

function removeErrors() {
  return {
    type: REMOVE_ERRORS
  };
}

function isLoaded(globalState) {
  return globalState.events && globalState.events.loaded;
}

function changeFilter(newFilter) {
  return { type: CHANGE_FILTER, newFilter: newFilter };
}

function load(queryString) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/events?' + _queryString2.default.stringify(queryString));
    }
  };
}

function newEvent(calendar) {
  return {
    type: EVENT_NEW,
    calendar: calendar
  };
}

function deleteImage(id) {
  return {
    types: [DELETE_IMAGE, DELETE_IMAGE_SUCCESS, DELETE_IMAGE_FAIL],
    promise: function promise(client) {
      return client.del('/images/' + id + '?type=event');
    }
  };
}

function destroy(id) {
  return {
    types: [DESTROY, DESTROY_SUCCESS, DESTROY_FAIL],
    id: id,
    promise: function promise(client) {
      return client.del('/events/' + id);
    }
  };
}

function getEvent(id, calendarId) {
  if (id) {
    return {
      types: [LOAD, EVENT_LOAD_SUCCESS, EVENT_LOAD_FAIL],
      promise: function promise(client) {
        return client.get('/events/' + id + '?include=translations' + (calendarId ? '&calendar_id=' + calendarId : ''));
      }
    };
  }
}

function restore(id) {
  return {
    types: [RESTORE, RESTORE_SUCCESS, RESTORE_FAIL],
    id: id,
    promise: function promise(client) {
      return client.put('/events/' + id + '/restore');
    }
  };
}

// Feature event
function feature(eventId, calendarId) {
  return {
    types: [FEATURE, FEATURE_SUCCESS, FEATURE_FAIL],
    id: eventId,
    promise: function promise(client) {
      return client.post('/calendars/' + calendarId + '/feature', {
        data: {
          event_id: eventId
        }
      });
    }
  };
}

function save(event) {
  var promise = void 0;
  if (event.id) {
    promise = function promise(client) {
      return client.put('/events/' + event.id, {
        data: event
      });
    };
  } else {
    promise = function promise(client) {
      return client.post('/events', {
        data: event
      });
    };
  }
  return {
    types: [SAVE, SAVE_SUCCESS, SAVE_FAIL],
    id: event.id,
    promise: promise
  };
}

function saveImage(image) {
  return {
    types: [SAVE_IMAGE, SAVE_IMAGE_SUCCESS, SAVE_IMAGE_FAIL],
    promise: function promise(client) {
      return client.post('/images?type=event', {
        image: image
      });
    }
  };
}

function search(input) {
  return {
    types: [SEARCH, SEARCH_SUCCESS, SEARCH_FAIL],
    promise: function promise(client) {
      return client.get('/events?' + _queryString2.default.stringify({ q: input }));
    }
  };
}

function unlink(id, calendarId) {
  return {
    types: [UNLINK, UNLINK_SUCCESS, UNLINK_FAIL],
    id: id,
    promise: function promise(client) {
      return client.del('/calendars/' + calendarId + '/events/' + id);
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/events.js
// module id = 338
// module chunks = 0